import { type SetLogsProps, type DeleteLogsProps, type AddLogProps, type AddLogsProps, type Log } from 'src/types'

const setLogs = (dispatch: (arg0: SetLogsProps) => void, logs: Log[]) => {
  dispatch({
    type: 'SET_LOGS',
    logs
  })
}

const deleteLogs = (dispatch: (arg0: DeleteLogsProps) => void) => {
  dispatch({
    type: 'DELETE_LOGS'
  })
}

const addLog = (dispatch: (arg0: AddLogProps) => void, log: Log) => {
  dispatch({
    type: 'ADD_LOG',
    log
  })
}

const addLogs = (dispatch: (arg0: AddLogsProps) => void, logs: Log[]) => {
  dispatch({
    type: 'ADD_LOGS',
    logs
  })
}

export {
  setLogs,
  deleteLogs,
  addLog,
  addLogs
}
